import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import DownArrow from "../../Assets/Icons/downArrow.png";
import Icon from "../../Assets/Icons";
import "./languageSwitcher.css";
import { setLoading } from "../../modules/loading/loadingSlice";
import { useSelector, useDispatch } from "react-redux";
import { setLanguage } from "../../modules/language/languageSlice";
import { languageSelect } from "../../modules/notification/notificationThunk";
import ToastPopup from "../../widgets/Toast/toastPopup";
import { resetLanguageSelect } from "../../modules/notification/notificationSlice";

function LanguageSwitcher() {
  const { t } = useTranslation();
  const { languageSelectSuccess, languageSelectErr } = useSelector((state) => state.notification);
  const dispatch = useDispatch();
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(i18n.language);
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (languageSelectErr) {
      // ToastPopup.error(languageSelectErr);
    }
    dispatch(resetLanguageSelect());
  }, [languageSelectErr, languageSelectSuccess]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  const handleDropdownToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (language) => {
    if (language !== selectedLanguage) {
      dispatch(setLoading(true));
      setSelectedLanguage(language);
      i18n.changeLanguage(language);
      setIsOpen(false);
      setTimeout(() => {
        dispatch(setLoading(false));
      }, 1000);
    }
  };
  useEffect(() => {
    if (selectedLanguage === "vietnam") {
      const data = {
        selectedLanguage: "VI",
      };
      dispatch(setLanguage(selectedLanguage));
      dispatch(languageSelect({data}));
    } else {
      const data = {
        selectedLanguage: "EN",
      };
      dispatch(setLanguage(selectedLanguage));
      dispatch(languageSelect({data}));
    }
  }, [selectedLanguage, dispatch]); 

  const getFlagImage = (language) => {
    switch (language) {
      case "en":
        return Icon.enFlag;
      case "vietnam":
        return Icon.vnFlag;
      case "french":
        return Icon.frFlag;
      default:
        return Icon.enFlag;
    }
  };

  return (
    <div className="sel-dropdown lng" ref={dropdownRef}>
      <div className="sel-dropdown-header lng" onClick={handleDropdownToggle}>
        <img src={getFlagImage(selectedLanguage)} alt="Selected Language" className="lng-flag-icon" />
        <span className={`sel-dropdown-arrow ${isOpen ? "open" : ""}`}>
          <img src={DownArrow} alt="Arrow Icon" />
        </span>
      </div>
      {isOpen && (
        <ul className="sel-dropdown-list lng">
          <li className={`sel-dropdown-item lng ${selectedLanguage === "vietnam" ? "selected" : ""}`} onClick={() => handleOptionClick("vietnam")}>
            {t("Vietnamese")}
          </li>
          <li className={`sel-dropdown-item lng ${selectedLanguage === "en" || selectedLanguage === "en-US" ? "selected" : ""}`} onClick={() => handleOptionClick("en")}>
            {t("English")}
          </li>

          {/* <li className={`sel-dropdown-item lng ${selectedLanguage === "french" ? "selected" : ""}`} onClick={() => handleOptionClick("french")}>
            French
          </li> */}
        </ul>
      )}
    </div>
  );
}

export default LanguageSwitcher;
